import { render, staticRenderFns } from "./base-ifp-filter.vue?vue&type=template&id=240bb54c&"
import script from "./base-ifp-filter.vue?vue&type=script&lang=ts&"
export * from "./base-ifp-filter.vue?vue&type=script&lang=ts&"
import style0 from "./base-ifp-filter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports